import { observer } from "mobx-react";
import RmaPageStore, { IRmaAction } from "../../stores/rma-page-store";
import { ConfirmModal } from "../../../../../components/modal/components/confirm-modal/confirm-modal";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IProps {
    rma: RmaPageStore;
    rmaAction: IRmaAction;
    onCloseClick: () => void;
}

const RmaActionConfirm: React.FC<IProps> = observer(({ rma, rmaAction, onCloseClick }) => {
    const actionStore = rmaAction.store;

    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-returns-rma-card';

    const onSubmit = () => {
        actionStore.submitAction(onCloseClick);
    };

    return <ConfirmModal
        title={rmaAction.modalTitleTranslationKey ? getTranslation(rmaAction.modalTitleTranslationKey, scope) : getTranslation(rmaAction.name, scope)}
        text={getTranslation(rmaAction.descriptionTranslationKey, scope)}
        cancelButton={{
            title: getTranslation('KEEP_CURRENT_STATUS', scope),
            onClick: () => onCloseClick()
        }} okButton={{
            title: getTranslation(rmaAction.buttonTextTranslationKey, scope),
            onClick: onSubmit,
            hasLoader: true,
            isLoading: actionStore.isProcessing,
        }}
    />
});

export default RmaActionConfirm;